import React from "react";
import {Navigate} from "react-router-dom";

interface HomeRedirectProps {
}

export const HomeRedirect: React.FC<HomeRedirectProps> = () => {

    const isLoggedIn = !!localStorage.getItem('token');

    if ( isLoggedIn ) {
        return (<Navigate to="/orders"/>);
    }

    return (<Navigate to="/login"/>);

}